<template>
  <v-container class="pa-4" fluid>
    <v-row v-if="hasNotificationAccess">
      <v-col class="grow">
        <v-switch
          v-model="jobAudibleAlertModel"
          :append-icon="jobVolumeIcon"
          label="Job notifications"
          style="margin-top: 8px"
        ></v-switch>
      </v-col>
      <v-col class="shrink">
        <v-btn text @click="playJobAudioSample">Play Example</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="hasChatAccess">
      <v-col class="grow">
        <v-switch
          v-model="chatAudibleAlertModel"
          :append-icon="chatVolumeIcon"
          label="Chat notifications"
          style="margin-top: 8px"
        ></v-switch>
      </v-col>
      <v-col class="shrink">
        <v-btn text @click="playChatAudioSample">Play Example</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { useChatStore } from '@/components/common/chat/useChatData'
import { computed } from 'vue'
import { useGetters } from 'vuex-composition-helpers'
import politeAlertAudio from '@/assets/polite_alert.mp3'
import messageAudio from '@/assets/message.mp3'

const NEW_CHAT_NOTIFICATION_AUDIO = new Audio(politeAlertAudio)
const NEW_JOB_NOTIFICATION_AUDIO = new Audio(messageAudio)

const store = useChatStore()

const { hasChatAccess, hasNotificationAccess } = useGetters('permissions', [
  'hasChatAccess',
  'hasNotificationAccess',
])

const jobAudibleAlert = computed(() => store.jobAudibleAlert)
const chatAudibleAlert = computed(() => store.chatAudibleAlert)

const jobVolumeIcon = computed(() => {
  return jobAudibleAlert.value ? 'volume_up' : 'volume_off'
})

const chatVolumeIcon = computed(() => {
  return chatAudibleAlert.value ? 'volume_up' : 'volume_off'
})

const chatAudibleAlertModel = computed({
  get() {
    return chatAudibleAlert.value
  },
  set(value) {
    store.updateChatAudibleAlert(value)
  },
})

const jobAudibleAlertModel = computed({
  get() {
    return jobAudibleAlert.value
  },
  set(value) {
    store.updateJobAudibleAlert(value)
  },
})

const playChatAudioSample = () => {
  NEW_CHAT_NOTIFICATION_AUDIO.play()
}
const playJobAudioSample = () => {
  NEW_JOB_NOTIFICATION_AUDIO.play()
}
</script>
